<template>
<div>
    <!-- modal -->
    <b-modal id="stateFormModal" centered size="lg" no-close-on-backdrop ref="stateFormModal" :title=" $t('state.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="clear()">

        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col class="col-lg-12">
                        <label for="state-country-input">{{ $t('state.country') }}</label>
                        <b-form-group>
                            <validation-provider :name=" $t('state.country')" :rules="{ excluded:0}" v-slot="{ errors }">
                                <b-form-select :state="errors.length > 0 ? false:null" v-model="countrySelect" value-field="id" text-field="name" size="sm" :options="countryOption" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-lg-12">
                        <validation-provider #default="{ errors }" :name=" $t('state.name')" rules="required">
                            <label for="state-name-input">{{ $t('state.name') }}</label>
                            <b-form-group>
                                <b-form-input id="state-name-input" v-model="stateName" maxlength="50" size="sm" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getStateList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            stateName: '',
            countrySelect: 0,
            countryOption: [],
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['stateFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'State'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.countryOption = response.data.countryList
                    this.countryOption.splice(0, 0, this.$nullSelected())
                    this.stateName = response.data.state.name
                    if (response.data.state.countryId > 0) {
                        this.countrySelect = response.data.state.countryId
                    }
                } else {
                    this.$bvModal.hide('stateFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.countrySelect = 0,
                this.stateName = ''
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.stateName,
                countryId: this.countrySelect
            }
            const controller = {
                name: 'State'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('stateFormModal')
                            this.getStateList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
